export default {
  email: 'Email',
  profile: 'Profile',
  linkedUser: 'Linked user',
  group: 'Group',
  groups: 'Groups',
  lastSeen: 'Last seen',
  appVersion: 'App version'
}
